export const SCENE_ANIMATION_8 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.158,0.402,-4.427,0.099,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.158,0.402,-4.427,0.099,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.08399999886751175,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.158,0.402,-4.427,0.099,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.10000000149011612,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.158,0.402,-4.427,0.100,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.11299999803304672,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.427,0.100,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.11500000208616257,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.427,0.100,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.12800000607967378,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.428,0.100,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.14300000667572022,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.428,0.100,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.1599999964237213,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.428,0.100,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.17299999296665193,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.428,0.100,0.637,-0.079,0.760"
            ]
        },
        {
            "time": 0.18700000643730164,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.428,0.100,0.637,-0.079,0.761"
            ]
        },
        {
            "time": 0.20200000703334809,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.429,0.100,0.637,-0.079,0.761"
            ]
        },
        {
            "time": 0.2160000056028366,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.429,0.100,0.636,-0.079,0.761"
            ]
        },
        {
            "time": 0.2280000001192093,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.429,0.100,0.636,-0.079,0.761"
            ]
        },
        {
            "time": 0.23899999260902406,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.429,0.100,0.636,-0.079,0.761"
            ]
        },
        {
            "time": 0.25,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.159,0.402,-4.430,0.100,0.636,-0.079,0.761"
            ]
        },
        {
            "time": 0.2630000114440918,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.430,0.100,0.636,-0.079,0.761"
            ]
        },
        {
            "time": 0.27399998903274538,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.430,0.100,0.636,-0.079,0.761"
            ]
        },
        {
            "time": 0.2840000092983246,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.431,0.100,0.636,-0.079,0.761"
            ]
        },
        {
            "time": 0.29499998688697817,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.431,0.100,0.636,-0.079,0.762"
            ]
        },
        {
            "time": 0.3059999942779541,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.431,0.100,0.635,-0.079,0.762"
            ]
        },
        {
            "time": 0.31700000166893008,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.431,0.100,0.635,-0.079,0.762"
            ]
        },
        {
            "time": 0.328000009059906,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.432,0.100,0.635,-0.079,0.762"
            ]
        },
        {
            "time": 0.33899998664855959,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.160,0.402,-4.432,0.100,0.635,-0.079,0.762"
            ]
        },
        {
            "time": 0.3499999940395355,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.161,0.403,-4.432,0.100,0.635,-0.079,0.762"
            ]
        },
        {
            "time": 0.36399999260902407,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.161,0.403,-4.433,0.100,0.635,-0.079,0.762"
            ]
        },
        {
            "time": 0.37400001287460329,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.161,0.403,-4.433,0.100,0.634,-0.078,0.762"
            ]
        },
        {
            "time": 0.3840000033378601,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.161,0.403,-4.434,0.100,0.634,-0.078,0.763"
            ]
        },
        {
            "time": 0.39500001072883608,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.161,0.403,-4.434,0.100,0.634,-0.078,0.763"
            ]
        },
        {
            "time": 0.40700000524520876,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.161,0.403,-4.434,0.100,0.634,-0.078,0.763"
            ]
        },
        {
            "time": 0.41999998688697817,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.162,0.403,-4.435,0.100,0.634,-0.078,0.763"
            ]
        },
        {
            "time": 0.4309999942779541,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.162,0.403,-4.435,0.100,0.634,-0.078,0.763"
            ]
        },
        {
            "time": 0.4410000145435333,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.162,0.403,-4.436,0.100,0.633,-0.078,0.763"
            ]
        },
        {
            "time": 0.45100000500679018,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.162,0.403,-4.436,0.100,0.633,-0.078,0.764"
            ]
        },
        {
            "time": 0.46399998664855959,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.162,0.403,-4.437,0.100,0.633,-0.078,0.764"
            ]
        },
        {
            "time": 0.4749999940395355,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.162,0.403,-4.437,0.100,0.633,-0.078,0.764"
            ]
        },
        {
            "time": 0.4880000054836273,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.163,0.403,-4.438,0.100,0.632,-0.078,0.764"
            ]
        },
        {
            "time": 0.49799999594688418,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.163,0.403,-4.438,0.100,0.632,-0.078,0.764"
            ]
        },
        {
            "time": 0.5070000290870667,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.163,0.403,-4.439,0.100,0.632,-0.078,0.764"
            ]
        },
        {
            "time": 0.5180000066757202,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.163,0.403,-4.439,0.100,0.632,-0.078,0.765"
            ]
        },
        {
            "time": 0.5299999713897705,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.163,0.403,-4.440,0.100,0.632,-0.078,0.765"
            ]
        },
        {
            "time": 0.5410000085830689,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.164,0.404,-4.440,0.100,0.631,-0.078,0.765"
            ]
        },
        {
            "time": 0.5540000200271606,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.164,0.404,-4.441,0.100,0.631,-0.078,0.765"
            ]
        },
        {
            "time": 0.5659999847412109,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.164,0.404,-4.441,0.100,0.631,-0.078,0.766"
            ]
        },
        {
            "time": 0.5809999704360962,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.164,0.404,-4.442,0.100,0.630,-0.078,0.766"
            ]
        },
        {
            "time": 0.5860000252723694,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.165,0.404,-4.443,0.100,0.630,-0.078,0.766"
            ]
        },
        {
            "time": 0.5979999899864197,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.165,0.404,-4.443,0.100,0.630,-0.078,0.766"
            ]
        },
        {
            "time": 0.6110000014305115,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.165,0.404,-4.444,0.101,0.630,-0.078,0.766"
            ]
        },
        {
            "time": 0.621999979019165,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.165,0.404,-4.444,0.101,0.629,-0.078,0.767"
            ]
        },
        {
            "time": 0.6309999823570252,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.166,0.404,-4.445,0.101,0.629,-0.078,0.767"
            ]
        },
        {
            "time": 0.6449999809265137,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.166,0.404,-4.445,0.101,0.629,-0.078,0.767"
            ]
        },
        {
            "time": 0.6539999842643738,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.166,0.404,-4.446,0.101,0.628,-0.078,0.767"
            ]
        },
        {
            "time": 0.6669999957084656,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.166,0.404,-4.447,0.101,0.628,-0.078,0.768"
            ]
        },
        {
            "time": 0.6830000281333923,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.167,0.404,-4.447,0.101,0.628,-0.078,0.768"
            ]
        },
        {
            "time": 0.6880000233650208,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.167,0.405,-4.448,0.101,0.627,-0.078,0.768"
            ]
        },
        {
            "time": 0.7020000219345093,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.167,0.405,-4.449,0.101,0.627,-0.078,0.768"
            ]
        },
        {
            "time": 0.7110000252723694,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.167,0.405,-4.450,0.101,0.627,-0.078,0.769"
            ]
        },
        {
            "time": 0.7250000238418579,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.168,0.405,-4.450,0.101,0.627,-0.078,0.769"
            ]
        },
        {
            "time": 0.734000027179718,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.168,0.405,-4.451,0.101,0.626,-0.078,0.769"
            ]
        },
        {
            "time": 0.746999979019165,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.168,0.405,-4.452,0.101,0.626,-0.078,0.769"
            ]
        },
        {
            "time": 0.7570000290870667,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.169,0.405,-4.452,0.101,0.626,-0.078,0.770"
            ]
        },
        {
            "time": 0.7739999890327454,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.169,0.405,-4.453,0.101,0.625,-0.078,0.770"
            ]
        },
        {
            "time": 0.781000018119812,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.169,0.405,-4.454,0.101,0.625,-0.077,0.770"
            ]
        },
        {
            "time": 0.7919999957084656,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.170,0.405,-4.455,0.101,0.625,-0.077,0.771"
            ]
        },
        {
            "time": 0.8029999732971191,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.170,0.405,-4.455,0.101,0.624,-0.077,0.771"
            ]
        },
        {
            "time": 0.8149999976158142,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.170,0.406,-4.456,0.101,0.624,-0.077,0.771"
            ]
        },
        {
            "time": 0.824999988079071,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.170,0.406,-4.457,0.101,0.623,-0.077,0.771"
            ]
        },
        {
            "time": 0.8379999995231628,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.171,0.406,-4.458,0.101,0.623,-0.077,0.772"
            ]
        },
        {
            "time": 0.8479999899864197,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.171,0.406,-4.459,0.101,0.623,-0.077,0.772"
            ]
        },
        {
            "time": 0.8600000143051148,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.171,0.406,-4.459,0.102,0.622,-0.077,0.772"
            ]
        },
        {
            "time": 0.8709999918937683,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.172,0.406,-4.460,0.102,0.622,-0.077,0.773"
            ]
        },
        {
            "time": 0.8809999823570252,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.172,0.406,-4.461,0.102,0.622,-0.077,0.773"
            ]
        },
        {
            "time": 0.8939999938011169,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.172,0.406,-4.462,0.102,0.621,-0.077,0.773"
            ]
        },
        {
            "time": 0.9039999842643738,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.173,0.406,-4.463,0.102,0.621,-0.077,0.774"
            ]
        },
        {
            "time": 0.9150000214576721,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.173,0.406,-4.463,0.102,0.620,-0.077,0.774"
            ]
        },
        {
            "time": 0.9259999990463257,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.173,0.407,-4.464,0.102,0.620,-0.077,0.774"
            ]
        },
        {
            "time": 0.9409999847412109,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.174,0.407,-4.465,0.102,0.620,-0.077,0.774"
            ]
        },
        {
            "time": 0.949999988079071,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.174,0.407,-4.466,0.102,0.619,-0.077,0.775"
            ]
        },
        {
            "time": 0.9629999995231628,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.175,0.407,-4.467,0.102,0.619,-0.077,0.775"
            ]
        },
        {
            "time": 0.9739999771118164,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.175,0.407,-4.468,0.102,0.618,-0.077,0.775"
            ]
        },
        {
            "time": 0.984000027179718,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.175,0.407,-4.469,0.102,0.618,-0.077,0.776"
            ]
        },
        {
            "time": 0.9950000047683716,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.176,0.407,-4.470,0.102,0.618,-0.077,0.776"
            ]
        },
        {
            "time": 1.00600004196167,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.176,0.407,-4.470,0.102,0.617,-0.077,0.776"
            ]
        },
        {
            "time": 1.0180000066757203,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.176,0.408,-4.471,0.102,0.617,-0.077,0.777"
            ]
        },
        {
            "time": 1.031000018119812,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.177,0.408,-4.472,0.102,0.616,-0.077,0.777"
            ]
        },
        {
            "time": 1.0420000553131104,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.177,0.408,-4.473,0.102,0.616,-0.077,0.778"
            ]
        },
        {
            "time": 1.0540000200271607,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.178,0.408,-4.474,0.102,0.615,-0.076,0.778"
            ]
        },
        {
            "time": 1.065999984741211,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.178,0.408,-4.475,0.102,0.615,-0.076,0.778"
            ]
        },
        {
            "time": 1.0789999961853028,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.178,0.408,-4.476,0.103,0.614,-0.076,0.779"
            ]
        },
        {
            "time": 1.0870000123977662,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.179,0.408,-4.477,0.103,0.614,-0.076,0.779"
            ]
        },
        {
            "time": 1.0980000495910645,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.179,0.408,-4.478,0.103,0.613,-0.076,0.779"
            ]
        },
        {
            "time": 1.1089999675750733,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.179,0.408,-4.479,0.103,0.613,-0.076,0.780"
            ]
        },
        {
            "time": 1.1200000047683716,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.180,0.409,-4.480,0.103,0.613,-0.076,0.780"
            ]
        },
        {
            "time": 1.1319999694824219,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.180,0.409,-4.481,0.103,0.612,-0.076,0.780"
            ]
        },
        {
            "time": 1.1430000066757203,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.181,0.409,-4.482,0.103,0.612,-0.076,0.781"
            ]
        },
        {
            "time": 1.156999945640564,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.181,0.409,-4.483,0.103,0.611,-0.076,0.781"
            ]
        },
        {
            "time": 1.1690000295639039,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.182,0.409,-4.484,0.103,0.611,-0.076,0.782"
            ]
        },
        {
            "time": 1.1799999475479127,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.182,0.409,-4.485,0.103,0.610,-0.076,0.782"
            ]
        },
        {
            "time": 1.190000057220459,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.182,0.409,-4.486,0.103,0.610,-0.076,0.782"
            ]
        },
        {
            "time": 1.2009999752044678,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.183,0.410,-4.487,0.103,0.609,-0.076,0.783"
            ]
        },
        {
            "time": 1.215000033378601,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.183,0.410,-4.488,0.103,0.609,-0.076,0.783"
            ]
        },
        {
            "time": 1.2239999771118165,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.184,0.410,-4.490,0.103,0.608,-0.076,0.784"
            ]
        },
        {
            "time": 1.2359999418258668,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.184,0.410,-4.491,0.103,0.608,-0.076,0.784"
            ]
        },
        {
            "time": 1.25,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.185,0.410,-4.492,0.103,0.607,-0.076,0.784"
            ]
        },
        {
            "time": 1.2589999437332154,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.185,0.410,-4.493,0.104,0.606,-0.076,0.785"
            ]
        },
        {
            "time": 1.2710000276565552,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.185,0.410,-4.494,0.104,0.606,-0.076,0.785"
            ]
        },
        {
            "time": 1.284000039100647,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.186,0.411,-4.495,0.104,0.606,-0.075,0.785"
            ]
        },
        {
            "time": 1.2999999523162842,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.186,0.411,-4.496,0.104,0.605,-0.075,0.786"
            ]
        },
        {
            "time": 1.3049999475479127,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.187,0.411,-4.498,0.104,0.604,-0.075,0.786"
            ]
        },
        {
            "time": 1.319000005722046,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.187,0.411,-4.498,0.104,0.604,-0.075,0.787"
            ]
        },
        {
            "time": 1.3279999494552613,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.188,0.411,-4.500,0.104,0.603,-0.075,0.787"
            ]
        },
        {
            "time": 1.340000033378601,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.188,0.411,-4.501,0.104,0.603,-0.075,0.787"
            ]
        },
        {
            "time": 1.3539999723434449,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.189,0.411,-4.502,0.104,0.602,-0.075,0.788"
            ]
        },
        {
            "time": 1.3639999628067017,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.189,0.412,-4.503,0.104,0.602,-0.075,0.788"
            ]
        },
        {
            "time": 1.3769999742507935,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.190,0.412,-4.504,0.104,0.601,-0.075,0.789"
            ]
        },
        {
            "time": 1.3880000114440919,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.190,0.412,-4.505,0.104,0.601,-0.075,0.789"
            ]
        },
        {
            "time": 1.3990000486373902,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.191,0.412,-4.507,0.104,0.600,-0.075,0.790"
            ]
        },
        {
            "time": 1.409999966621399,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.191,0.412,-4.508,0.104,0.599,-0.075,0.790"
            ]
        },
        {
            "time": 1.4210000038146973,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.191,0.412,-4.509,0.105,0.599,-0.075,0.790"
            ]
        },
        {
            "time": 1.434000015258789,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.192,0.412,-4.510,0.105,0.598,-0.075,0.791"
            ]
        },
        {
            "time": 1.444000005722046,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.193,0.413,-4.511,0.105,0.598,-0.075,0.791"
            ]
        },
        {
            "time": 1.4579999446868897,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.193,0.413,-4.512,0.105,0.597,-0.075,0.792"
            ]
        },
        {
            "time": 1.4700000286102296,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.194,0.413,-4.514,0.105,0.596,-0.074,0.792"
            ]
        },
        {
            "time": 1.4789999723434449,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.194,0.413,-4.515,0.105,0.596,-0.074,0.793"
            ]
        },
        {
            "time": 1.4930000305175782,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.194,0.413,-4.516,0.105,0.595,-0.074,0.793"
            ]
        },
        {
            "time": 1.503000020980835,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.195,0.413,-4.517,0.105,0.595,-0.074,0.794"
            ]
        },
        {
            "time": 1.5140000581741334,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.195,0.414,-4.519,0.105,0.594,-0.074,0.794"
            ]
        },
        {
            "time": 1.5260000228881837,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.196,0.414,-4.520,0.105,0.594,-0.074,0.794"
            ]
        },
        {
            "time": 1.5379999876022339,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.196,0.414,-4.521,0.105,0.593,-0.074,0.795"
            ]
        },
        {
            "time": 1.5499999523162842,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.197,0.414,-4.522,0.105,0.592,-0.074,0.795"
            ]
        },
        {
            "time": 1.5609999895095826,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.197,0.414,-4.524,0.105,0.592,-0.074,0.796"
            ]
        },
        {
            "time": 1.5729999542236329,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.198,0.414,-4.525,0.106,0.591,-0.074,0.796"
            ]
        },
        {
            "time": 1.5850000381469727,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.199,0.415,-4.526,0.106,0.591,-0.074,0.797"
            ]
        },
        {
            "time": 1.5980000495910645,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.199,0.415,-4.527,0.106,0.590,-0.074,0.797"
            ]
        },
        {
            "time": 1.6109999418258668,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.200,0.415,-4.529,0.106,0.589,-0.074,0.798"
            ]
        },
        {
            "time": 1.621999979019165,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.200,0.415,-4.530,0.106,0.589,-0.074,0.798"
            ]
        },
        {
            "time": 1.6339999437332154,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.201,0.415,-4.532,0.106,0.588,-0.074,0.799"
            ]
        },
        {
            "time": 1.6449999809265137,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.201,0.415,-4.533,0.106,0.587,-0.074,0.799"
            ]
        },
        {
            "time": 1.656999945640564,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.202,0.416,-4.534,0.106,0.587,-0.073,0.799"
            ]
        },
        {
            "time": 1.6690000295639039,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.202,0.416,-4.535,0.106,0.586,-0.073,0.800"
            ]
        },
        {
            "time": 1.6799999475479127,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.203,0.416,-4.537,0.106,0.585,-0.073,0.800"
            ]
        },
        {
            "time": 1.694000005722046,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.203,0.416,-4.538,0.106,0.585,-0.073,0.801"
            ]
        },
        {
            "time": 1.7039999961853028,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.204,0.416,-4.540,0.106,0.584,-0.073,0.801"
            ]
        },
        {
            "time": 1.715000033378601,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.204,0.416,-4.541,0.106,0.583,-0.073,0.802"
            ]
        },
        {
            "time": 1.7259999513626099,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.205,0.417,-4.542,0.107,0.583,-0.073,0.802"
            ]
        },
        {
            "time": 1.7419999837875367,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.205,0.417,-4.543,0.107,0.582,-0.073,0.803"
            ]
        },
        {
            "time": 1.75,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.206,0.417,-4.545,0.107,0.581,-0.073,0.803"
            ]
        },
        {
            "time": 1.7640000581741334,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.207,0.417,-4.546,0.107,0.581,-0.073,0.804"
            ]
        },
        {
            "time": 1.7730000019073487,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.207,0.417,-4.548,0.107,0.580,-0.073,0.804"
            ]
        },
        {
            "time": 1.7869999408721924,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.208,0.417,-4.549,0.107,0.580,-0.073,0.805"
            ]
        },
        {
            "time": 1.7970000505447388,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.208,0.418,-4.550,0.107,0.579,-0.073,0.805"
            ]
        },
        {
            "time": 1.809999942779541,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.209,0.418,-4.552,0.107,0.578,-0.073,0.806"
            ]
        },
        {
            "time": 1.8209999799728394,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.209,0.418,-4.553,0.107,0.577,-0.072,0.806"
            ]
        },
        {
            "time": 1.8350000381469727,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.210,0.418,-4.554,0.107,0.577,-0.072,0.807"
            ]
        },
        {
            "time": 1.8450000286102296,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.211,0.418,-4.556,0.107,0.576,-0.072,0.807"
            ]
        },
        {
            "time": 1.8580000400543213,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.211,0.418,-4.557,0.107,0.575,-0.072,0.808"
            ]
        },
        {
            "time": 1.86899995803833,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.212,0.419,-4.559,0.108,0.575,-0.072,0.808"
            ]
        },
        {
            "time": 1.8819999694824219,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.212,0.419,-4.560,0.108,0.574,-0.072,0.809"
            ]
        },
        {
            "time": 1.8919999599456788,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.213,0.419,-4.562,0.108,0.573,-0.072,0.809"
            ]
        },
        {
            "time": 1.906000018119812,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.213,0.419,-4.563,0.108,0.573,-0.072,0.809"
            ]
        },
        {
            "time": 1.9179999828338624,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.214,0.419,-4.564,0.108,0.572,-0.072,0.810"
            ]
        },
        {
            "time": 1.9279999732971192,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.215,0.420,-4.566,0.108,0.571,-0.072,0.810"
            ]
        },
        {
            "time": 1.9420000314712525,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.215,0.420,-4.567,0.108,0.571,-0.072,0.811"
            ]
        },
        {
            "time": 1.9529999494552613,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.216,0.420,-4.569,0.108,0.570,-0.072,0.811"
            ]
        },
        {
            "time": 1.9639999866485596,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.216,0.420,-4.570,0.108,0.569,-0.072,0.812"
            ]
        },
        {
            "time": 1.9780000448226929,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.217,0.420,-4.571,0.108,0.569,-0.071,0.812"
            ]
        },
        {
            "time": 1.9889999628067017,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.218,0.421,-4.573,0.108,0.568,-0.071,0.813"
            ]
        },
        {
            "time": 1.9989999532699586,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.218,0.421,-4.574,0.108,0.567,-0.071,0.813"
            ]
        },
        {
            "time": 2.0139999389648439,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.219,0.421,-4.576,0.109,0.566,-0.071,0.814"
            ]
        },
        {
            "time": 2.0299999713897707,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.219,0.421,-4.578,0.109,0.565,-0.071,0.814"
            ]
        },
        {
            "time": 2.0369999408721926,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.220,0.421,-4.579,0.109,0.565,-0.071,0.815"
            ]
        },
        {
            "time": 2.0480000972747804,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.220,0.421,-4.580,0.109,0.564,-0.071,0.815"
            ]
        },
        {
            "time": 2.062000036239624,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.221,0.422,-4.582,0.109,0.563,-0.071,0.816"
            ]
        },
        {
            "time": 2.0739998817443849,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.222,0.422,-4.583,0.109,0.563,-0.071,0.816"
            ]
        },
        {
            "time": 2.0850000381469728,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.222,0.422,-4.585,0.109,0.562,-0.071,0.817"
            ]
        },
        {
            "time": 2.0959999561309816,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.223,0.422,-4.586,0.109,0.561,-0.071,0.817"
            ]
        },
        {
            "time": 2.1080000400543215,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.223,0.422,-4.588,0.109,0.561,-0.071,0.818"
            ]
        },
        {
            "time": 2.121999979019165,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.224,0.423,-4.589,0.109,0.560,-0.070,0.818"
            ]
        },
        {
            "time": 2.134000062942505,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.225,0.423,-4.591,0.109,0.559,-0.070,0.819"
            ]
        },
        {
            "time": 2.1470000743865969,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.225,0.423,-4.592,0.110,0.558,-0.070,0.819"
            ]
        },
        {
            "time": 2.1559998989105226,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.226,0.423,-4.594,0.110,0.557,-0.070,0.820"
            ]
        },
        {
            "time": 2.1710000038146974,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.226,0.423,-4.595,0.110,0.557,-0.070,0.820"
            ]
        },
        {
            "time": 2.181999921798706,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.227,0.424,-4.597,0.110,0.556,-0.070,0.821"
            ]
        },
        {
            "time": 2.193000078201294,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.228,0.424,-4.598,0.110,0.555,-0.070,0.821"
            ]
        },
        {
            "time": 2.2070000171661379,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.228,0.424,-4.600,0.110,0.555,-0.070,0.822"
            ]
        },
        {
            "time": 2.2170000076293947,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.229,0.424,-4.601,0.110,0.554,-0.070,0.823"
            ]
        },
        {
            "time": 2.2290000915527345,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.229,0.424,-4.603,0.110,0.553,-0.070,0.823"
            ]
        },
        {
            "time": 2.243000030517578,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.230,0.424,-4.604,0.110,0.552,-0.070,0.823"
            ]
        },
        {
            "time": 2.253999948501587,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.231,0.425,-4.606,0.110,0.551,-0.070,0.824"
            ]
        },
        {
            "time": 2.265000104904175,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.231,0.425,-4.607,0.110,0.551,-0.069,0.824"
            ]
        },
        {
            "time": 2.2790000438690187,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.232,0.425,-4.609,0.110,0.550,-0.069,0.825"
            ]
        },
        {
            "time": 2.2920000553131105,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.233,0.425,-4.611,0.111,0.549,-0.069,0.825"
            ]
        },
        {
            "time": 2.302000045776367,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.233,0.425,-4.612,0.111,0.548,-0.069,0.826"
            ]
        },
        {
            "time": 2.313999891281128,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.234,0.426,-4.613,0.111,0.548,-0.069,0.826"
            ]
        },
        {
            "time": 2.3259999752044679,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.234,0.426,-4.615,0.111,0.547,-0.069,0.827"
            ]
        },
        {
            "time": 2.3380000591278078,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.235,0.426,-4.616,0.111,0.546,-0.069,0.827"
            ]
        },
        {
            "time": 2.3519999980926515,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.236,0.426,-4.618,0.111,0.545,-0.069,0.828"
            ]
        },
        {
            "time": 2.36899995803833,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.236,0.426,-4.620,0.111,0.544,-0.069,0.829"
            ]
        },
        {
            "time": 2.375,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.237,0.427,-4.622,0.111,0.543,-0.069,0.829"
            ]
        },
        {
            "time": 2.3889999389648439,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.238,0.427,-4.623,0.111,0.543,-0.069,0.829"
            ]
        },
        {
            "time": 2.4019999504089357,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.238,0.427,-4.624,0.111,0.542,-0.069,0.830"
            ]
        },
        {
            "time": 2.4140000343322756,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.239,0.427,-4.626,0.111,0.541,-0.068,0.831"
            ]
        },
        {
            "time": 2.424999952316284,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.240,0.427,-4.628,0.112,0.541,-0.068,0.831"
            ]
        },
        {
            "time": 2.438999891281128,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.240,0.428,-4.629,0.112,0.540,-0.068,0.831"
            ]
        },
        {
            "time": 2.4509999752044679,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.241,0.428,-4.631,0.112,0.539,-0.068,0.832"
            ]
        },
        {
            "time": 2.4609999656677248,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.241,0.428,-4.632,0.112,0.538,-0.068,0.833"
            ]
        },
        {
            "time": 2.4730000495910646,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.242,0.428,-4.634,0.112,0.538,-0.068,0.833"
            ]
        },
        {
            "time": 2.484999895095825,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.243,0.428,-4.635,0.112,0.537,-0.068,0.833"
            ]
        },
        {
            "time": 2.496999979019165,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.243,0.429,-4.637,0.112,0.536,-0.068,0.834"
            ]
        },
        {
            "time": 2.51200008392334,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.244,0.429,-4.638,0.112,0.535,-0.068,0.834"
            ]
        },
        {
            "time": 2.5239999294281008,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.245,0.429,-4.640,0.112,0.534,-0.068,0.835"
            ]
        },
        {
            "time": 2.5339999198913576,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.245,0.429,-4.642,0.112,0.534,-0.068,0.836"
            ]
        },
        {
            "time": 2.5490000247955324,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.246,0.429,-4.643,0.112,0.533,-0.067,0.836"
            ]
        },
        {
            "time": 2.565000057220459,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.246,0.430,-4.645,0.113,0.532,-0.067,0.837"
            ]
        },
        {
            "time": 2.575000047683716,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.247,0.430,-4.647,0.113,0.531,-0.067,0.837"
            ]
        },
        {
            "time": 2.5829999446868898,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.248,0.430,-4.648,0.113,0.530,-0.067,0.838"
            ]
        },
        {
            "time": 2.5950000286102297,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.248,0.430,-4.649,0.113,0.530,-0.067,0.838"
            ]
        },
        {
            "time": 2.609999895095825,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.249,0.430,-4.651,0.113,0.529,-0.067,0.838"
            ]
        },
        {
            "time": 2.621000051498413,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.250,0.431,-4.652,0.113,0.528,-0.067,0.839"
            ]
        },
        {
            "time": 2.634000062942505,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.250,0.431,-4.654,0.113,0.527,-0.067,0.839"
            ]
        },
        {
            "time": 2.6470000743865969,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.251,0.431,-4.655,0.113,0.526,-0.067,0.840"
            ]
        },
        {
            "time": 2.6570000648498537,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.252,0.431,-4.657,0.113,0.526,-0.067,0.841"
            ]
        },
        {
            "time": 2.6710000038146974,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.252,0.431,-4.658,0.113,0.525,-0.067,0.841"
            ]
        },
        {
            "time": 2.681999921798706,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.253,0.432,-4.660,0.113,0.524,-0.066,0.841"
            ]
        },
        {
            "time": 2.694999933242798,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.253,0.432,-4.662,0.114,0.523,-0.066,0.842"
            ]
        },
        {
            "time": 2.7079999446868898,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.254,0.432,-4.663,0.114,0.522,-0.066,0.842"
            ]
        },
        {
            "time": 2.7200000286102297,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.255,0.432,-4.665,0.114,0.522,-0.066,0.843"
            ]
        },
        {
            "time": 2.7309999465942385,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.255,0.432,-4.666,0.114,0.521,-0.066,0.843"
            ]
        },
        {
            "time": 2.744999885559082,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.256,0.433,-4.668,0.114,0.520,-0.066,0.844"
            ]
        },
        {
            "time": 2.756999969482422,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.257,0.433,-4.670,0.114,0.519,-0.066,0.844"
            ]
        },
        {
            "time": 2.7690000534057619,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.257,0.433,-4.671,0.114,0.519,-0.066,0.845"
            ]
        },
        {
            "time": 2.7809998989105226,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.258,0.433,-4.672,0.114,0.518,-0.066,0.845"
            ]
        },
        {
            "time": 2.7920000553131105,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.258,0.433,-4.674,0.114,0.517,-0.066,0.846"
            ]
        },
        {
            "time": 2.806999921798706,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.259,0.434,-4.675,0.114,0.516,-0.066,0.846"
            ]
        },
        {
            "time": 2.819000005722046,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.260,0.434,-4.677,0.114,0.515,-0.065,0.847"
            ]
        },
        {
            "time": 2.8289999961853029,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.260,0.434,-4.679,0.115,0.515,-0.065,0.847"
            ]
        },
        {
            "time": 2.8429999351501467,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.261,0.434,-4.680,0.115,0.514,-0.065,0.848"
            ]
        },
        {
            "time": 2.8559999465942385,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.262,0.434,-4.682,0.115,0.513,-0.065,0.848"
            ]
        },
        {
            "time": 2.868000030517578,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.262,0.435,-4.683,0.115,0.512,-0.065,0.849"
            ]
        },
        {
            "time": 2.88100004196167,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.263,0.435,-4.685,0.115,0.511,-0.065,0.849"
            ]
        },
        {
            "time": 2.8919999599456789,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.263,0.435,-4.686,0.115,0.511,-0.065,0.850"
            ]
        },
        {
            "time": 2.9040000438690187,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.264,0.435,-4.688,0.115,0.510,-0.065,0.850"
            ]
        },
        {
            "time": 2.9189999103546144,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.265,0.435,-4.689,0.115,0.509,-0.065,0.851"
            ]
        },
        {
            "time": 2.928999900817871,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.265,0.436,-4.691,0.115,0.508,-0.065,0.851"
            ]
        },
        {
            "time": 2.943000078201294,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.266,0.436,-4.692,0.115,0.508,-0.065,0.851"
            ]
        },
        {
            "time": 2.9549999237060549,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.267,0.436,-4.694,0.115,0.507,-0.064,0.852"
            ]
        },
        {
            "time": 2.9660000801086427,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.267,0.436,-4.696,0.115,0.506,-0.064,0.852"
            ]
        },
        {
            "time": 2.9779999256134035,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.268,0.436,-4.697,0.116,0.505,-0.064,0.853"
            ]
        },
        {
            "time": 2.992000102996826,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.268,0.437,-4.698,0.116,0.504,-0.064,0.853"
            ]
        },
        {
            "time": 3.003999948501587,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.269,0.437,-4.700,0.116,0.504,-0.064,0.854"
            ]
        },
        {
            "time": 3.015000104904175,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.270,0.437,-4.702,0.116,0.503,-0.064,0.854"
            ]
        },
        {
            "time": 3.0309998989105226,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.270,0.437,-4.703,0.116,0.502,-0.064,0.855"
            ]
        },
        {
            "time": 3.0420000553131105,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.271,0.437,-4.705,0.116,0.501,-0.064,0.855"
            ]
        },
        {
            "time": 3.055000066757202,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.271,0.438,-4.706,0.116,0.500,-0.064,0.856"
            ]
        },
        {
            "time": 3.066999912261963,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.272,0.438,-4.708,0.116,0.500,-0.064,0.856"
            ]
        },
        {
            "time": 3.078000068664551,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.273,0.438,-4.709,0.116,0.499,-0.064,0.857"
            ]
        },
        {
            "time": 3.0929999351501467,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.273,0.438,-4.711,0.116,0.498,-0.063,0.857"
            ]
        },
        {
            "time": 3.1029999256134035,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.274,0.438,-4.712,0.116,0.497,-0.063,0.857"
            ]
        },
        {
            "time": 3.117000102996826,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.274,0.438,-4.714,0.116,0.497,-0.063,0.858"
            ]
        },
        {
            "time": 3.128999948501587,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.275,0.439,-4.715,0.117,0.496,-0.063,0.858"
            ]
        },
        {
            "time": 3.140000104904175,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.276,0.439,-4.717,0.117,0.495,-0.063,0.859"
            ]
        },
        {
            "time": 3.1549999713897707,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.276,0.439,-4.718,0.117,0.494,-0.063,0.859"
            ]
        },
        {
            "time": 3.1649999618530275,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.277,0.439,-4.720,0.117,0.493,-0.063,0.860"
            ]
        },
        {
            "time": 3.178999900817871,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.277,0.439,-4.721,0.117,0.493,-0.063,0.860"
            ]
        },
        {
            "time": 3.196000099182129,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.278,0.440,-4.723,0.117,0.492,-0.063,0.860"
            ]
        },
        {
            "time": 3.2039999961853029,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.279,0.440,-4.725,0.117,0.491,-0.063,0.861"
            ]
        },
        {
            "time": 3.2149999141693117,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.279,0.440,-4.725,0.117,0.490,-0.063,0.861"
            ]
        },
        {
            "time": 3.2290000915527345,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.280,0.440,-4.727,0.117,0.490,-0.063,0.862"
            ]
        },
        {
            "time": 3.239000082015991,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.280,0.440,-4.728,0.117,0.489,-0.062,0.862"
            ]
        },
        {
            "time": 3.253999948501587,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.281,0.441,-4.730,0.117,0.488,-0.062,0.863"
            ]
        },
        {
            "time": 3.2660000324249269,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.282,0.441,-4.731,0.117,0.487,-0.062,0.863"
            ]
        },
        {
            "time": 3.2780001163482668,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.282,0.441,-4.733,0.117,0.487,-0.062,0.863"
            ]
        },
        {
            "time": 3.2909998893737795,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.283,0.441,-4.734,0.118,0.486,-0.062,0.864"
            ]
        },
        {
            "time": 3.308000087738037,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.283,0.441,-4.736,0.118,0.485,-0.062,0.864"
            ]
        },
        {
            "time": 3.315000057220459,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.284,0.442,-4.737,0.118,0.484,-0.062,0.865"
            ]
        },
        {
            "time": 3.328000068664551,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.284,0.442,-4.738,0.118,0.484,-0.062,0.865"
            ]
        },
        {
            "time": 3.3389999866485597,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.285,0.442,-4.740,0.118,0.483,-0.062,0.866"
            ]
        },
        {
            "time": 3.3540000915527345,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.285,0.442,-4.741,0.118,0.482,-0.062,0.866"
            ]
        },
        {
            "time": 3.367000102996826,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.286,0.442,-4.743,0.118,0.481,-0.062,0.866"
            ]
        },
        {
            "time": 3.377000093460083,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.287,0.442,-4.744,0.118,0.481,-0.061,0.867"
            ]
        },
        {
            "time": 3.3889999389648439,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.287,0.443,-4.745,0.118,0.480,-0.061,0.867"
            ]
        },
        {
            "time": 3.4019999504089357,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.288,0.443,-4.747,0.118,0.479,-0.061,0.867"
            ]
        },
        {
            "time": 3.4159998893737795,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.288,0.443,-4.748,0.118,0.479,-0.061,0.868"
            ]
        },
        {
            "time": 3.428999900817871,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.289,0.443,-4.750,0.118,0.478,-0.061,0.868"
            ]
        },
        {
            "time": 3.440999984741211,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.290,0.443,-4.751,0.118,0.477,-0.061,0.869"
            ]
        },
        {
            "time": 3.4509999752044679,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.290,0.443,-4.752,0.119,0.476,-0.061,0.869"
            ]
        },
        {
            "time": 3.4660000801086427,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.291,0.444,-4.753,0.119,0.476,-0.061,0.869"
            ]
        },
        {
            "time": 3.4790000915527345,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.291,0.444,-4.755,0.119,0.475,-0.061,0.870"
            ]
        },
        {
            "time": 3.489000082015991,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.292,0.444,-4.756,0.119,0.474,-0.061,0.870"
            ]
        },
        {
            "time": 3.503000020980835,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.292,0.444,-4.757,0.119,0.474,-0.061,0.871"
            ]
        },
        {
            "time": 3.5199999809265138,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.293,0.444,-4.759,0.119,0.473,-0.061,0.871"
            ]
        },
        {
            "time": 3.5269999504089357,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.293,0.444,-4.761,0.119,0.472,-0.060,0.872"
            ]
        },
        {
            "time": 3.5390000343322756,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.294,0.445,-4.762,0.119,0.471,-0.060,0.872"
            ]
        },
        {
            "time": 3.552000045776367,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.294,0.445,-4.763,0.119,0.471,-0.060,0.872"
            ]
        },
        {
            "time": 3.566999912261963,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.295,0.445,-4.764,0.119,0.470,-0.060,0.872"
            ]
        },
        {
            "time": 3.5789999961853029,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.295,0.445,-4.766,0.119,0.469,-0.060,0.873"
            ]
        },
        {
            "time": 3.5899999141693117,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.296,0.445,-4.767,0.119,0.469,-0.060,0.873"
            ]
        },
        {
            "time": 3.6040000915527345,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.296,0.445,-4.768,0.119,0.468,-0.060,0.874"
            ]
        },
        {
            "time": 3.619999885559082,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.297,0.446,-4.769,0.119,0.467,-0.060,0.874"
            ]
        },
        {
            "time": 3.630000114440918,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.298,0.446,-4.771,0.120,0.466,-0.060,0.874"
            ]
        },
        {
            "time": 3.6389999389648439,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.298,0.446,-4.772,0.120,0.466,-0.060,0.875"
            ]
        },
        {
            "time": 3.6530001163482668,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.298,0.446,-4.773,0.120,0.465,-0.060,0.875"
            ]
        },
        {
            "time": 3.6640000343322756,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.299,0.446,-4.775,0.120,0.465,-0.060,0.875"
            ]
        },
        {
            "time": 3.6760001182556154,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.299,0.446,-4.776,0.120,0.464,-0.059,0.876"
            ]
        },
        {
            "time": 3.690999984741211,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.300,0.447,-4.777,0.120,0.463,-0.059,0.876"
            ]
        },
        {
            "time": 3.7009999752044679,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.301,0.447,-4.778,0.120,0.463,-0.059,0.876"
            ]
        },
        {
            "time": 3.7160000801086427,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.301,0.447,-4.779,0.120,0.462,-0.059,0.877"
            ]
        },
        {
            "time": 3.7279999256134035,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.302,0.447,-4.781,0.120,0.461,-0.059,0.877"
            ]
        },
        {
            "time": 3.740000009536743,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.302,0.447,-4.782,0.120,0.461,-0.059,0.877"
            ]
        },
        {
            "time": 3.750999927520752,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.302,0.447,-4.783,0.120,0.460,-0.059,0.878"
            ]
        },
        {
            "time": 3.7660000324249269,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.303,0.447,-4.784,0.120,0.460,-0.059,0.878"
            ]
        },
        {
            "time": 3.7780001163482668,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.303,0.448,-4.785,0.120,0.459,-0.059,0.878"
            ]
        },
        {
            "time": 3.7890000343322756,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.304,0.448,-4.787,0.120,0.458,-0.059,0.879"
            ]
        },
        {
            "time": 3.803999900817871,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.304,0.448,-4.788,0.120,0.458,-0.059,0.879"
            ]
        },
        {
            "time": 3.815000057220459,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.305,0.448,-4.789,0.121,0.457,-0.059,0.879"
            ]
        },
        {
            "time": 3.8289999961853029,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.305,0.448,-4.790,0.121,0.456,-0.059,0.880"
            ]
        },
        {
            "time": 3.8429999351501467,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.306,0.448,-4.791,0.121,0.456,-0.058,0.880"
            ]
        },
        {
            "time": 3.8519999980926515,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.306,0.449,-4.793,0.121,0.455,-0.058,0.880"
            ]
        },
        {
            "time": 3.865999937057495,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.307,0.449,-4.793,0.121,0.455,-0.058,0.881"
            ]
        },
        {
            "time": 3.877000093460083,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.307,0.449,-4.795,0.121,0.454,-0.058,0.881"
            ]
        },
        {
            "time": 3.890000104904175,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.308,0.449,-4.796,0.121,0.453,-0.058,0.881"
            ]
        },
        {
            "time": 3.9040000438690187,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.308,0.449,-4.797,0.121,0.453,-0.058,0.881"
            ]
        },
        {
            "time": 3.9149999618530275,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.309,0.449,-4.798,0.121,0.452,-0.058,0.882"
            ]
        },
        {
            "time": 3.927999973297119,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.309,0.449,-4.799,0.121,0.452,-0.058,0.882"
            ]
        },
        {
            "time": 3.940000057220459,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.309,0.450,-4.800,0.121,0.451,-0.058,0.882"
            ]
        },
        {
            "time": 3.953000068664551,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.310,0.450,-4.801,0.121,0.450,-0.058,0.883"
            ]
        },
        {
            "time": 3.9649999141693117,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.310,0.450,-4.802,0.121,0.450,-0.058,0.883"
            ]
        },
        {
            "time": 3.9760000705718996,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.311,0.450,-4.803,0.121,0.449,-0.058,0.883"
            ]
        },
        {
            "time": 3.990999937057495,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.311,0.450,-4.804,0.121,0.449,-0.058,0.883"
            ]
        },
        {
            "time": 4.000999927520752,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.312,0.450,-4.805,0.121,0.448,-0.058,0.884"
            ]
        },
        {
            "time": 4.017000198364258,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.312,0.450,-4.806,0.121,0.448,-0.058,0.884"
            ]
        },
        {
            "time": 4.026000022888184,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.312,0.450,-4.807,0.121,0.447,-0.057,0.884"
            ]
        },
        {
            "time": 4.039000034332275,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.313,0.451,-4.808,0.122,0.447,-0.057,0.885"
            ]
        },
        {
            "time": 4.053999900817871,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.313,0.451,-4.809,0.122,0.446,-0.057,0.885"
            ]
        },
        {
            "time": 4.068999767303467,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.314,0.451,-4.810,0.122,0.446,-0.057,0.885"
            ]
        },
        {
            "time": 4.078000068664551,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.314,0.451,-4.812,0.122,0.445,-0.057,0.885"
            ]
        },
        {
            "time": 4.0879998207092289,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.314,0.451,-4.812,0.122,0.445,-0.057,0.886"
            ]
        },
        {
            "time": 4.10099983215332,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.315,0.451,-4.813,0.122,0.444,-0.057,0.886"
            ]
        },
        {
            "time": 4.11299991607666,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.315,0.451,-4.814,0.122,0.444,-0.057,0.886"
            ]
        },
        {
            "time": 4.127999782562256,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.315,0.451,-4.815,0.122,0.443,-0.057,0.886"
            ]
        },
        {
            "time": 4.138000011444092,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.316,0.452,-4.816,0.122,0.443,-0.057,0.887"
            ]
        },
        {
            "time": 4.1529998779296879,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.316,0.452,-4.817,0.122,0.442,-0.057,0.887"
            ]
        },
        {
            "time": 4.164000034332275,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.317,0.452,-4.818,0.122,0.442,-0.057,0.887"
            ]
        },
        {
            "time": 4.181000232696533,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.317,0.452,-4.819,0.122,0.441,-0.057,0.887"
            ]
        },
        {
            "time": 4.191999912261963,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.317,0.452,-4.820,0.122,0.440,-0.057,0.888"
            ]
        },
        {
            "time": 4.199999809265137,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.318,0.452,-4.820,0.122,0.440,-0.057,0.888"
            ]
        },
        {
            "time": 4.2129998207092289,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.318,0.452,-4.821,0.122,0.440,-0.057,0.888"
            ]
        },
        {
            "time": 4.2270002365112309,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.318,0.452,-4.822,0.122,0.439,-0.057,0.888"
            ]
        },
        {
            "time": 4.239999771118164,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.319,0.452,-4.823,0.122,0.439,-0.056,0.888"
            ]
        },
        {
            "time": 4.250999927520752,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.319,0.453,-4.824,0.122,0.438,-0.056,0.889"
            ]
        },
        {
            "time": 4.263000011444092,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.319,0.453,-4.824,0.122,0.438,-0.056,0.889"
            ]
        },
        {
            "time": 4.2779998779296879,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.320,0.453,-4.825,0.122,0.438,-0.056,0.889"
            ]
        },
        {
            "time": 4.290999889373779,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.320,0.453,-4.826,0.122,0.437,-0.056,0.889"
            ]
        },
        {
            "time": 4.307000160217285,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.320,0.453,-4.827,0.123,0.437,-0.056,0.890"
            ]
        },
        {
            "time": 4.313000202178955,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.321,0.453,-4.828,0.123,0.436,-0.056,0.890"
            ]
        },
        {
            "time": 4.328000068664551,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.321,0.453,-4.828,0.123,0.436,-0.056,0.890"
            ]
        },
        {
            "time": 4.339000225067139,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.321,0.453,-4.829,0.123,0.435,-0.056,0.890"
            ]
        },
        {
            "time": 4.353000164031982,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.321,0.453,-4.830,0.123,0.435,-0.056,0.890"
            ]
        },
        {
            "time": 4.36299991607666,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.322,0.453,-4.831,0.123,0.435,-0.056,0.890"
            ]
        },
        {
            "time": 4.377999782562256,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.322,0.453,-4.831,0.123,0.434,-0.056,0.891"
            ]
        },
        {
            "time": 4.390999794006348,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.322,0.454,-4.832,0.123,0.434,-0.056,0.891"
            ]
        },
        {
            "time": 4.406000137329102,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.323,0.454,-4.833,0.123,0.433,-0.056,0.891"
            ]
        },
        {
            "time": 4.414999961853027,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.323,0.454,-4.834,0.123,0.433,-0.056,0.891"
            ]
        },
        {
            "time": 4.425000190734863,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.323,0.454,-4.834,0.123,0.433,-0.056,0.891"
            ]
        },
        {
            "time": 4.438000202178955,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.323,0.454,-4.835,0.123,0.432,-0.056,0.891"
            ]
        },
        {
            "time": 4.453000068664551,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.324,0.454,-4.835,0.123,0.432,-0.056,0.892"
            ]
        },
        {
            "time": 4.464000225067139,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.324,0.454,-4.836,0.123,0.432,-0.056,0.892"
            ]
        },
        {
            "time": 4.4770002365112309,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.324,0.454,-4.837,0.123,0.431,-0.056,0.892"
            ]
        },
        {
            "time": 4.48799991607666,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.324,0.454,-4.837,0.123,0.431,-0.056,0.892"
            ]
        },
        {
            "time": 4.500999927520752,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.325,0.454,-4.838,0.123,0.431,-0.055,0.892"
            ]
        },
        {
            "time": 4.514999866485596,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.325,0.454,-4.838,0.123,0.431,-0.055,0.892"
            ]
        },
        {
            "time": 4.526000022888184,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.325,0.454,-4.839,0.123,0.430,-0.055,0.893"
            ]
        },
        {
            "time": 4.538000106811523,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.325,0.455,-4.839,0.123,0.430,-0.055,0.893"
            ]
        },
        {
            "time": 4.552999973297119,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.326,0.455,-4.840,0.123,0.430,-0.055,0.893"
            ]
        },
        {
            "time": 4.563000202178955,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.326,0.455,-4.841,0.123,0.429,-0.055,0.893"
            ]
        },
        {
            "time": 4.576000213623047,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.326,0.455,-4.841,0.123,0.429,-0.055,0.893"
            ]
        },
        {
            "time": 4.591000080108643,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.326,0.455,-4.841,0.123,0.429,-0.055,0.893"
            ]
        },
        {
            "time": 4.6020002365112309,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.326,0.455,-4.842,0.123,0.428,-0.055,0.893"
            ]
        },
        {
            "time": 4.614999771118164,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.327,0.455,-4.842,0.123,0.428,-0.055,0.894"
            ]
        },
        {
            "time": 4.631999969482422,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.327,0.455,-4.843,0.123,0.428,-0.055,0.894"
            ]
        },
        {
            "time": 4.638999938964844,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.327,0.455,-4.844,0.123,0.428,-0.055,0.894"
            ]
        },
        {
            "time": 4.651000022888184,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.327,0.455,-4.844,0.123,0.428,-0.055,0.894"
            ]
        },
        {
            "time": 4.665999889373779,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.327,0.455,-4.844,0.123,0.427,-0.055,0.894"
            ]
        },
        {
            "time": 4.676000118255615,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.327,0.455,-4.845,0.123,0.427,-0.055,0.894"
            ]
        },
        {
            "time": 4.688000202178955,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.328,0.455,-4.845,0.123,0.427,-0.055,0.894"
            ]
        },
        {
            "time": 4.703999996185303,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.328,0.455,-4.845,0.123,0.427,-0.055,0.894"
            ]
        },
        {
            "time": 4.716000080108643,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.328,0.455,-4.846,0.123,0.426,-0.055,0.894"
            ]
        },
        {
            "time": 4.73199987411499,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.328,0.455,-4.846,0.123,0.426,-0.055,0.894"
            ]
        },
        {
            "time": 4.73799991607666,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.328,0.455,-4.847,0.124,0.426,-0.055,0.895"
            ]
        },
        {
            "time": 4.750999927520752,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.328,0.455,-4.847,0.124,0.426,-0.055,0.895"
            ]
        },
        {
            "time": 4.763999938964844,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.328,0.456,-4.847,0.124,0.426,-0.055,0.895"
            ]
        },
        {
            "time": 4.7779998779296879,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.847,0.124,0.426,-0.055,0.895"
            ]
        },
        {
            "time": 4.788000106811523,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.848,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.801000118255615,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.848,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.815999984741211,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.848,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.831999778747559,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.848,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.841000080108643,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.849,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.85099983215332,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.849,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.863999843597412,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.849,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.875999927520752,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.849,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.889999866485596,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.849,0.124,0.425,-0.055,0.895"
            ]
        },
        {
            "time": 4.901000022888184,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.849,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 4.915999889373779,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 4.932000160217285,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.329,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 4.940999984741211,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.330,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 4.953000068664551,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.330,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 4.965000152587891,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.330,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 4.979000091552734,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.330,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 4.989999771118164,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.330,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        },
        {
            "time": 5.004000186920166,
            "data": [
                "senior,-1.495,0.000,-4.193,0.000,-0.920,0.000,0.393",
                "police7,-1.567,0.000,-3.935,0.000,-0.925,0.000,0.380",
                "police8,-1.248,0.000,-4.250,0.000,-0.842,0.000,0.539",
                "reporter3,-1.735,-0.006,-4.180,-0.030,-0.448,0.012,-0.893",
                "reporter4,-1.559,-0.004,-4.415,0.000,0.190,0.000,0.982",
                "observationCamera,-2.330,0.456,-4.850,0.124,0.424,-0.055,0.895"
            ]
        }
    ]
};